import { Instance } from 'mobx-state-tree';
import { RevokeServiceAccountDtoModelBase } from './RevokeServiceAccountDtoModel.base';

/* The TypeScript type of an instance of RevokeServiceAccountDtoModel */
export interface RevokeServiceAccountDtoModelType extends Instance<typeof RevokeServiceAccountDtoModel.Type> {}

/* A graphql query fragment builders for RevokeServiceAccountDtoModel */
export { selectFromRevokeServiceAccountDto, revokeServiceAccountDtoModelPrimitives, RevokeServiceAccountDtoModelSelector } from './RevokeServiceAccountDtoModel.base';

/**
 * RevokeServiceAccountDtoModel
 */
export const RevokeServiceAccountDtoModel = RevokeServiceAccountDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
